import { TwitterLogoIcon } from "@radix-ui/react-icons";
import { InstagramIcon, Facebook } from "lucide-react";
function Footer() {
  return (
    <>
      <footer className="main-footer py-16 pb-10">
        <div class="max-w-7xl mx-auto px-4">
          {/* Top Section */}
          <div className="flex flex-col space-x-10 md:flex-row justify-between items-start md:items-center">
            {/* Logo and Main Text */}
            <div className="mb-6 md:mb-0">
              <h2 class="text-3xl md:text-5xl mb-5 secdory-font">
                We&apos;re here when you&apos;re ready
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center md:text-left">
                <div>
                  <p className="text-gray-500">Phone Number</p>
                  <h3 className="text-lg text-gray-900 font-medium secdory-font">
                    0761-8523-398
                  </h3>
                </div>
                <div>
                  <p className="text-gray-500">Email Address</p>
                  <h3 className="text-lg text-gray-900 font-medium secdory-font">
                    info@domainname.com
                  </h3>
                </div>
                <div>
                  <p className="text-gray-500">Location</p>
                  <h3 className="text-lg text-gray-900 font-medium secdory-font">
                    123 High Street LNI 1AB United Kingdom
                  </h3>
                </div>
              </div>
            </div>

            {/* Contact Info */}

            {/* Community Links */}
            <div className="mt-6 md:mt-0">
              <h3 className="text-lg font-medium text-gray-900 secdory-font">
                Join Our Community
              </h3>
              <p className="text-md text-slate-600 ">
                Join us today for resources, insight & connection
              </p>
              <div className="flex space-x-3 mt-4">
                <a
                  href="#"
                  className="border rounded-full p-2 text-gray-600 hover:text-gray-900"
                >
                  <TwitterLogoIcon className="w-5 h-5" />
                </a>
                <a
                  href="#"
                  className="border rounded-full p-2 text-gray-600 hover:text-gray-900"
                >
                  <Facebook className="w-5 h-5" />
                </a>
                <a
                  href="#"
                  className="border rounded-full p-2 text-gray-600 hover:text-gray-900"
                >
                  <InstagramIcon className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>

          {/* Divider */}
          <hr className="my-8 border-gray-200" />

          {/* Bottom Links */}
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
            <div className="flex space-x-6 mb-4 md:mb-0">
              <a href="#" className="hover:text-gray-900">
                Home
              </a>
              <a href="#" className="hover:text-gray-900">
                About Us
              </a>
              <a href="#" className="hover:text-gray-900">
                Services
              </a>
              <a href="#" className="hover:text-gray-900">
                Blog
              </a>
              <a href="#" className="hover:text-gray-900">
                Contact Us
              </a>
            </div>
            <p>Copyright © 2024 All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
